import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { collection, query, where, onSnapshot, getDocs, orderBy, Timestamp } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext.jsx';
import { MdArrowBackIos, MdClose, MdPrint, MdFileDownload, MdSearch, MdOutlineLocalPrintshop } from "react-icons/md";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import Print_receipt_order from "../print_root/print_receipt_order.js";
import Print_receipt_a4 from "../print_root/print_receipt_a4.js";
import Settingprint_popup from "../print_setting_root/settingprint_popup.jsx";
import CopyUID from "../../components_root/copyuid.jsx";
import ShareButton from "../../components_root/ShareButton.jsx";
import { No_transactions } from "../../components_root/no_transactions.jsx";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services.",
    keywords: "aooz services, free online tools, premium tools, seo tools",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Account_statement() {
    const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const { Toastshow } = Toast();
    const [reportsrata, setReportsData] = useState([]);
    const navigate = useNavigate();
    const [from_date, setFrom_date] = useState("");
    const [to_date, setTo_date] = useState("");
    const [accountguid, setaccountguid] = useState(null);
    const [settingprintopen, setSettingprintopen] = useState(false);
    const [printpage, setPrintpage] = useState("account_statement");
    const [printapply, setPrintapply] = useState("");
    const [printid, setPrintid] = useState("");
    const [printdata, setPrintdata] = useState([]);
    const [select_company_uid, setSelect_company_uid] = useState(null);
    const [guid, setGuid] = useState(null);
    const [voucherprintid, setVoucherprintid] = useState("");
    const [account_data, setAccount_data] = useState([]);

    useEffect(() => {
        setGuid(Cookies.get("guid"));
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("accountguid");

        if (uid) {
            setaccountguid(uid);
        } else {
            navigate(-1);
        }
    }, [window.location.search, navigate]);

    useEffect(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        const firstDay = `${year}-${month}-01`;
        const currentDay = `${year}-${month}-${day}`;

        setFrom_date(firstDay);
        setTo_date(currentDay);
    }, []);

    const get_Reports = () => {
        setIsLoading2(true);

        if (!select_company_uid || !accountguid || !from_date || !to_date) {
            setIsLoading2(false);
            return;
        }

        const startDate = new Date(`${from_date}T00:00:00`);
        const endDate = new Date(`${to_date}T23:59:59.999`);

        if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
            console.error("Invalid date range format");
            setIsLoading2(false);
            return;
        }

        const startTimestamp = Timestamp.fromDate(startDate);
        const endTimestamp = Timestamp.fromDate(endDate);

        const ledgerRef = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );

        const productQuery = query(
            ledgerRef,
            where("accountguid", "==", accountguid),
            where("date_time", ">=", startTimestamp),
            where("date_time", "<=", endTimestamp),
            orderBy("date_time", "desc")
        );

        const unsubscribe = onSnapshot(
            productQuery,
            async (snapshot) => {
                try {
                    const vouchers = await Promise.all(
                        snapshot.docs.map(async (docSnap) => {
                            const data = docSnap.data();

                            const printRef = collection(
                                db,
                                servicetablename,
                                select_company_uid,
                                "voucher_print"
                            );

                            const printQuery = query(
                                printRef,
                                where("vouchernumber", "==", data.voucherid)
                            );

                            const printSnapshot = await getDocs(printQuery);

                            const printData = printSnapshot.docs.map((doc) => ({
                                id: doc.id,
                                ...doc.data(),
                            }));

                            return {
                                id: docSnap.id,
                                ...data,
                                printData
                            };
                        })
                    );

                    setReportsData(vouchers);
                    setIsLoading2(false);
                } catch (error) {
                    console.error("Error processing vouchers:", error);
                    setIsLoading2(false);
                }
            },
            (error) => {
                console.error("Error fetching vouchers from Firestore:", error);
                setIsLoading2(false);
            }
        );

        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribe = get_Reports();
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [select_company_uid, accountguid, from_date, to_date]);

    const fetch_accounts = async () => {
        if (!accountguid) return;
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        try {
            setIsLoading2(true);
            const primaryQuery = query(
                collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                where("accountguid", "==", accountguid)
            );
            const snapshot = await getDocs(primaryQuery);
            if (!snapshot.empty) {
                const accountSnap = await getDocs(
                    query(collection(db, "accounts"), where("guid", "==", accountguid))
                );

                let accountInfo = {};
                if (!accountSnap.empty) {
                    accountInfo = {
                        account_id: accountSnap.docs[0].id,
                        ...accountSnap.docs[0].data(),
                    };
                }

                const mergedData = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                    account_info: accountInfo,
                }));

                setAccount_data(mergedData);
                setIsLoading2(false);
                return;
            }

            const fallbackQuery = query(
                collection(db, "accountingfinancedb", select_company_uid, "ledger_accounts"),
                where("accountguid", "==", accountguid)
            );

            const fallbackSnap = await getDocs(fallbackQuery);
            const mergedData = fallbackSnap.docs.map((docSnap) => {
                const ledgerData = { id: docSnap.id, ...docSnap.data() };
                return { ...ledgerData, account_info: ledgerData };
            });

            setAccount_data(mergedData);
            setIsLoading2(false);
        } catch (error) {
            console.error("Error fetching accounts:", error);
            setIsLoading2(false);
        }
    };

    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);

    const accountName = account_data?.[0]?.account_info?.name || account_data?.[0]?.name || "N/A";

    // 🧮 Calculate Total Credit and Total Debit
    const totalCredit = reportsrata.reduce((sum, row) => sum + (parseFloat(row.credit) || 0), 0);
    const totalDebit = reportsrata.reduce((sum, row) => sum + (parseFloat(row.debit) || 0), 0);

    const downloadPDF = () => {
        if (!reportsrata || reportsrata.length === 0) {
            alert("No data to generate report");
            return;
        }

        const tableRows = reportsrata.map((row) => {
            const dateTime = row.date_time?.toDate
                ? `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                : "No date";

            const print = row.printData?.[0];
            const referNumber = print?.refer_number ? `${print.refer_number}<br/>` : "";
            const remarks = print?.remarks ? `${print.remarks}<br/>` : "";

            return `
        <tr>
            <td class="bold">${row.tokennumber || "0"}</td>
            <td width={130}>
                <a class="text-h2 bold">${row.voucher_type?.replaceAll("_", " ") || "N/A"}</a><br/>
                <a class="bold">${row.voucherid || "0"}</a><br/>
                <a class="text-h4">${dateTime}</a>
            </td>
            <td>
                <a class="text-h3 fcap">
                   <a class="bold">${referNumber}</a>
                    ${remarks}
                    ${row.particulars || "N/A"}
                </a>
            </td>
            <td width={80}>${row.credit === 0 || row.credit == null ? "--" : Number(row.credit).toFixed(2)}</td>
            <td width={80}>${row.debit === 0 || row.debit == null ? "--" : Number(row.debit).toFixed(2)}</td>
            <td width={90}>${row.balance === 0 || row.balance == null ? "--" : Number(row.balance).toFixed(2)}</td>
        </tr>`;
        }).join("");

        const content = `
        <div>
            <table>
                <tr>
                    <td>
                        <div class="title_sub">${printdata.print_title || "Account Statement"}</div>
                        <div class="text-h2">${printdata.print_tagline || ""}</div>
                        <div class="text-h3">${printdata.print_contactinfo || ""}</div>
                        <div class="text-h3 bold">${printdata.print_address || ""}</div>
                    </td>
                    <td style="text-align:right">
                        <div class="text-h1">Account Statement</div>
                        <div class="text-h2 bold fcap">${accountName}</div> 
                        <div class="text-h2">A/c: ${account_data[0]?.accountnumber || "N/A"}</div> 
                        <div class="text-h2">Period: <b>${from_date} to ${to_date}</b></div> 
                        <div class="text-h3">Print ${new Date().toLocaleString()}</div>
                    </td>
                </tr>
            </table>

            <div class="items-back-fill"> 
                <table class="report-table">
                    <thead>
                        <tr> 
                            <th>Token</th> 
                            <th>Date & Time</th> 
                            <th>Particulars</th>
                            <th>Credit</th>
                            <th>Debit</th>
                            <th>Balance</th>
                        </tr>
                    </thead>
                    <tbody>${tableRows}</tbody> 
                    <tfoot>
                        <tr>
                            <td colspan="3" style="text-align:right; font-weight:bold;">Total:</td>
                            <td style="font-weight:bold;">${totalCredit.toFixed(2)}</td>
                            <td style="font-weight:bold;">${totalDebit.toFixed(2)}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <table class="p-2">
                 <tr><td class="bold text-h2">Service by: Aooz.in</td></tr>
            </table>
        </div>`;

        const printWindow = window.open("", "", "width=1200,height=800");
        printWindow.document.write(`
        <html>
        <head>
            <title>Account Statement</title>
            <style>
                @page { size: A4 portrait; margin: 10mm; }
                body { font-family: Arial, sans-serif; margin: 0; }
                table { width: 100%; border-collapse: collapse; page-break-inside: auto; }
                thead { display: table-header-group; }
                tfoot { display: table-footer-group; }
                tr { page-break-inside: avoid; }
                .report-table th, .report-table td { border: 1px solid #ccc; padding:1px 5px; font-size: 11px; word-break: break-word; }
                .report-table thead tr, .report-table tfoot tr { background: #f0f0f0; }
                .bold { font-weight: bold; }
                .fcap { text-transform: capitalize; }
                .title_sub { font-size: 18px; font-weight: bold; }
                .text-h2 { font-size: 12px; }
                .text-h3 { font-size: 10px; }
                .text-h4 { font-size: 9px; }
                .items-back-fill { border: 1px solid #000; margin: 2px 0; }
            </style>
        </head>
        <body>${content}</body>
        </html>`);

        printWindow.document.close();
        printWindow.print();
    };

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") navigate(-1);
        };
        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [navigate]);

    useEffect(() => {
        if (!select_company_uid || !printid) return;
        const q = query(
            collection(db, "accountingfinancedb", select_company_uid, "print_setting"),
            where("printid", "==", printid)
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            const settingArray = data[0]?.settingdata || [];
            const settingObj = Object.fromEntries(settingArray.map(item => [item.key, item.value]));
            setPrintdata(settingObj);
        });

        return () => unsub();
    }, [select_company_uid, printid]);

    useEffect(() => {
        if (!select_company_uid || !guid || !printpage) return;

        const applyQuery = query(
            collection(db, servicetablename, select_company_uid, "print_settings_account_apply"),
            where("guid", "==", guid),
            where("status", "==", true),
            where("printpage", "==", printpage)
        );

        const unsubscribe = onSnapshot(applyQuery, (snapshot) => {
            if (snapshot.empty) {
                setPrintapply(null);
                return;
            }
            setPrintapply(snapshot.docs[0]?.data()?.printsize ?? null);
            setPrintid(snapshot.docs[0]?.data()?.printid ?? null);
        });

        return () => unsubscribe;
    }, [select_company_uid, guid, printpage]);

    const PrintReceiptVoucher = (id) => {
        setVoucherprintid(id);
        setTimeout(() => setVoucherprintid(""), 2000);
    };

    return (
        <div>
            <div className="items-back">
                <div className="b-bottom">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div onClick={() => navigate(-1)} className="button-ui0 text-h2 bold p-2 cursor">
                                        <MdArrowBackIos className="icon" />Account statement
                                    </div>
                                </td>
                                <td width={30}>
                                    <div onClick={() => navigate("/accounting")} className="button-ui0 p-2 cursor">
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="post-container p-2">
                    <div className="ui-grid">
                        <div className="ui-items items-back p-2">
                            <Ledger_accounts_profile accountguid={accountguid} />
                        </div>

                        <div className="ui-items items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <input
                                                value={from_date}
                                                type="date"
                                                onChange={(e) => setFrom_date(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                value={to_date}
                                                type="date"
                                                onChange={(e) => setTo_date(e.target.value)}
                                            />
                                        </td>
                                        <td>
                                            <div onClick={() => get_Reports()} className="button-ui2 p-1">
                                                <MdSearch className="icon cursor" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="ui-items items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="button-ui2 p-1 cursor" title="Download PDF" onClick={downloadPDF}>
                                                <MdFileDownload className="icon cursor" />PDF Download
                                            </div>
                                        </td>
                                        <td width={100}>
                                            <div className="button-ui p-1 cursor" onClick={() => setSettingprintopen(true)}>
                                                <MdOutlineLocalPrintshop className="icon cursor" />Set <div className="bold">{printapply}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="post-container p-2">
                    <div className="post_div">
                        <div className="ui-grid_voucher">
                            {IsLoading2 ? (
                                <></>
                            ) : reportsrata.length === 0 ? (
                                <No_transactions message="Statement" />
                            ) : (
                                <>
                                    {window.innerWidth > 768 ? (
                                        /* ============================
                                           DESKTOP VIEW: Table with tfoot Totals
                                           ============================ */
                                        <table className="voucher-table-desktop">
                                            <thead>
                                                <tr>
                                                    <th>Voucher Id</th>
                                                    <th>Date & Time</th>
                                                    <th>Voucher</th>
                                                    <th>Particulars</th>
                                                    <th className="text-r">Credit</th>
                                                    <th className="text-r">Debit</th>
                                                    <th className="text-r">Balance</th>
                                                    <th>Share</th>
                                                    <th>Print</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {reportsrata.map((row) => (
                                                    <tr key={row.id || row.ledgerid} className="tr_hover">
                                                        <td width={30} className="text-h3">
                                                            <div className="button-ui0">
                                                                {row.voucherid || "0"}
                                                                <CopyUID id={row.voucherid} />
                                                            </div>
                                                        </td>
                                                        <td width={130} className="text-h3">
                                                            {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                "No date"
                                                            )}
                                                        </td>
                                                        <td className="text-h2 fcap bold">
                                                            {row.voucher_type?.replaceAll("_", " ").replaceAll("-", " ") || "N/A"}
                                                        </td>
                                                        <td>
                                                            <a>
                                                                {(() => {
                                                                    const print = row.printData?.[0];
                                                                    return (
                                                                        <>
                                                                            {print?.refer_number && <>{print.refer_number}<br /></>}
                                                                            {print?.remarks && <>{print.remarks}<br /></>}
                                                                            {row.particulars || ""}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </a>
                                                        </td>
                                                        <td width={80} className="text-h2 text-r" style={{ color: row.credit === 0 ? "#999" : "" }}>
                                                            {row.credit === 0 || row.credit === undefined ? "--" : row.credit.toFixed(2)}
                                                        </td>
                                                        <td width={80} className="text-h2 text-r" style={{ color: row.debit === 0 ? "#999" : "" }}>
                                                            {row.debit === 0 || row.debit === undefined ? "--" : row.debit.toFixed(2)}
                                                        </td>
                                                        <td width={80} className="text-h2 text-r bold" style={{ color: row.balance === 0 ? "#999" : "" }}>
                                                            {row.balance === 0 || row.balance === undefined ? "--" : row.balance.toFixed(2)}
                                                        </td>
                                                        <td width={30}><ShareButton url={row.slug} /></td>
                                                        <td className="p-11" width={30}>
                                                            <div className="button-ui0 cursor" onClick={() => PrintReceiptVoucher(row.voucherprintid)}>
                                                                <MdPrint className="icon" />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            {/* ✅ Total row at bottom of Desktop Table */}
                                            <tfoot>
                                                <tr style={{ background: "#f4f5f8", borderTop: "2px solid #ccc" }}>
                                                    <td colSpan={4} className="text-r bold text-h2">Total:</td>
                                                    <td className="text-h2 text-r bold" style={{ color: "#16a34a" }}>
                                                        {totalCredit === 0 ? "--" : totalCredit.toFixed(2)}
                                                    </td>
                                                    <td className="text-h2 text-r bold" style={{ color: "#dc2626" }}>
                                                        {totalDebit === 0 ? "--" : totalDebit.toFixed(2)}
                                                    </td>
                                                    <td colSpan={3}></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    ) : (
                                        /* ============================
                                           MOBILE VIEW: Cards + Totals Footer
                                           ============================ */
                                        <>
                                            {reportsrata.map((row) => (
                                                <div className="ui-items items-back p-11 shadow hover rounded cursor" key={row.voucherid || row.id}>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <div className="text-h1 bold fcap">{row.voucher || "Voucher Not found"}</div>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <table>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <div className="text-h2 fcap bold">{row.namepaying || "No name"}</div>
                                                                                </td>
                                                                                <td className="text-r text-h2">{row.code}{row.mobile || " N/A"}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <table className="b-top">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td><div className="text-h3">Token #{row.tokennumber || "0"}</div></td>
                                                                                <td width={140} className="text-h3 text-r">
                                                                                    {row.date_time?.toDate ? (
                                                                                        `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                                                                                    ) : (
                                                                                        "No date"
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <table className="b-top">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td><div className="text-h2 bold">₹{row.amount || "0"} /-</div></td>
                                                                                <td><div className="text-h3 text-r">ID: {row.voucherprintid || "0"}</div></td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ))}

                                            {/* ✅ Totals Card at bottom of Mobile View */}
                                            <div className="ui-items items-back p-11 shadow rounded" style={{ borderTop: "2px solid #000", marginTop: "10px" }}>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-h2 bold">Total Credit:</td>
                                                            <td className="text-h2 text-r bold" style={{ color: "#16a34a" }}>
                                                                {totalCredit === 0 ? "--" : `₹${totalCredit.toFixed(2)}`}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-h2 bold">Total Debit:</td>
                                                            <td className="text-h2 text-r bold" style={{ color: "#dc2626" }}>
                                                                {totalDebit === 0 ? "--" : `₹${totalDebit.toFixed(2)}`}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {voucherprintid && printapply === "4INCH" && (
                <Print_receipt_order voucherprintid={voucherprintid} printid={printid} />
            )}
            {voucherprintid && printapply === "A4" && (
                <Print_receipt_a4 voucherprintid={voucherprintid} printid={printid} />
            )}
            <Settingprint_popup data={printpage} isOpen={settingprintopen} onClose={() => setSettingprintopen(false)} />
        </div>
    );
}